"use client";

import React from "react";
import { Container } from "semantic-ui-react";

/**
 * Client-safe wrapper for Semantic UI Container component
 * Can be used in Server Components for SSR + SEO
 */
export default function ContainerShim({ children, ...props }) {
  return <Container {...props}>{children}</Container>;
}
